export default __webpack_public_path__ + "static/media/expert-wizard.5508554e.svg";